module.exports = __webpack_public_path__ + "static/media/h310.4b9155ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/injectionMoulds/h310.jpg
// module id = 199
// module chunks = 0